import { formatTimestampToDateTime } from '../../../utils/conversion'

export function convertTrackingListToTabs(trackingList) {
  if (!Array.isArray(trackingList)) return []

  const sortedList = [...trackingList].sort((a, b) => b.timestamp - a.timestamp)

  return sortedList.map((item, index) => ({
    id: item.id,
    label: index === 0 ? 'latest' : `${item.timestamp}.log`,
    content: formatTrackingContentAsJSX(item),
  }))
}

export function formatTrackingContentAsJSX(item) {
  const trackingParams = JSON.parse(item.tracking_param || '{}')

  return (
    <div>
      <p>
        <strong>Timestamp:</strong> {formatTimestampToDateTime(item.timestamp)}
      </p>
      <p>
        <strong>Tracking ID:</strong> {item.tracking_id}
      </p>
      <p>
        <strong>Action:</strong> {item.tracking_action}
      </p>
      <p>
        <strong>Screen:</strong> {item.tracking_screen}
      </p>
      <p>
        <strong>Parameters:</strong>
      </p>
      <pre>{JSON.stringify(trackingParams, null, 2)}</pre>
    </div>
  )
}
